var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgWhatsAppFeedbackAlert = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), React.createElement("g", {
    clipPath: "url(#WhatsAppFeedbackAlert_svg__a)"
  }, getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M61.664 55.23 55.96 40.634c-.67-1.705-.434-4.112 1.233-4.994.532-.29 1.004-.5 1.576-.51l-2.806-19.965c-.258-1.835-2.022-3.17-3.919-2.903l-22.696 3.19c-1.897.266-3.235 1.965-2.967 3.87l6.604 46.988c.258 1.834 2.022 3.169 3.919 2.902L57.63 66.3c1.466-5.89 4.033-11.07 4.033-11.07Z"
  }), React.createElement("rect", {
    width: 20.977,
    height: 3.173,
    fill: "var(--color-neutral-80)",
    rx: 1.587,
    transform: "rotate(-7.96 211.896 -193.978) skewX(.08)"
  }), React.createElement("rect", {
    width: 22.824,
    height: 3.174,
    fill: "var(--color-neutral-80)",
    rx: 1.587,
    transform: "rotate(-7.961 342.468 -203.114) skewX(.079)"
  }), React.createElement("rect", {
    width: 17.532,
    height: 3.173,
    fill: "var(--color-neutral-80)",
    rx: 1.586,
    transform: "rotate(-7.959 240.675 -196.475) skewX(.082)"
  }), React.createElement("rect", {
    width: 13.778,
    height: 3.172,
    fill: "var(--color-neutral-80)",
    rx: 1.586,
    transform: "rotate(-7.958 416.512 -211.838) skewX(.084)"
  }), React.createElement("rect", {
    width: 25.225,
    height: 3.174,
    fill: "var(--color-neutral-80)",
    rx: 1.587,
    transform: "rotate(-7.961 445.633 -205.098) skewX(.077)"
  }), React.createElement("rect", {
    width: 20.977,
    height: 3.173,
    fill: color,
    rx: 1.587,
    transform: "rotate(-7.96 274.578 -239.993) skewX(.08)"
  }), React.createElement("rect", {
    width: 17.164,
    height: 3.173,
    fill: color,
    rx: 1.586,
    transform: "rotate(-7.959 300.362 -270.378) skewX(.082)"
  }), React.createElement("rect", {
    width: 21.905,
    height: 3.173,
    fill: color,
    rx: 1.587,
    transform: "rotate(-7.96 376.627 -246.654) skewX(.079)"
  }), React.createElement("path", {
    fill: color,
    d: "M26.625 18.476a1.996 1.996 0 0 1 1.7-2.257l25-3.494a2.004 2.004 0 0 1 2.26 1.704l.995 7.039-28.96 4.047-.995-7.039Z"
  }), React.createElement("rect", {
    width: 9.16,
    height: 1.267,
    fill: "var(--color-neutral-70)",
    rx: 0.634,
    transform: "rotate(-7.973 170.568 -233.052) skewX(.054)"
  }), React.createElement("rect", {
    width: 3.814,
    height: 3.802,
    fill: "var(--color-neutral-70)",
    rx: 1.901,
    transform: "rotate(-7.973 162.703 -196.923) skewX(.054)"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M71.905 52.484c-2.982-4.904-5.855-9.823-8.837-14.728-.57-.999-1.81-2.255-1.81-2.255-1.872-1.427-6.231.209-5.554 2.991.548 2.37 2.127 5.842 2.946 8.101 1.109 2.794 1.836 5.307 2.945 8.1-2.013 3.521-3.608 7.856-4.418 11.783l-17.132 2.655c.931 8.391 10.601 15.777 10.601 15.777 2.195 1.85 4.526 6.199 4.526 6.199s2.005 1.144 11.137 0c9.132-1.144 10.75-3.275 10.75-3.275-1.507-4.105-2.4-5.926-2.945-10.31-.663-5.23-.2-10.256 0-15.464.036-3.315-.438-6.657-2.209-9.574Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m53.846 67.645 3.112 8.09v-8.713l-3.112.623Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M55.183 91.177s-2.28-4.5-4.526-6.199c-2.966-2.245-9.448-8.6-10.6-15.777"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M55.261 91.74a.534.534 0 0 1-.541-.283c-.01-.07-2.2-4.44-4.355-6.007-3.458-2.68-9.65-9.004-10.801-16.18-.04-.283.131-.594.412-.634.281-.04.592.133.632.415 1.092 6.753 7.043 12.895 10.41 15.444 2.326 1.76 4.596 6.189 4.696 6.39.11.273.01.575-.252.755-.06.08-.13.09-.2.1Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m59.449 59.558-3.734-20.536 5.6 15.557-1.866 4.979Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M57.396 75.918c-2.12-9.99 4.271-21.104 4.271-21.104l-5.775-15.089c-.669-1.704.067-3.606 1.664-4.478 1.667-.882 3.754-.312 4.695 1.283l9.507 15.642c1.49 2.453 2.239 5.226 2.284 8.097 0 0-.504 13.237.11 17.611.437 3.105 2.804 9.75 2.804 9.75"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M76.966 88.205c-.21.03-.512-.072-.551-.354-.11-.272-2.377-6.717-2.824-9.891-.614-4.375-.12-17.178-.05-17.692-.025-2.73-.763-5.432-2.244-7.814L61.799 36.88a3.01 3.01 0 0 0-4.022-1.09c-1.336.692-1.961 2.363-1.401 3.795l5.774 15.088c.09.132.05.353-.01.434-.06.08-6.332 11.034-4.25 20.742.039.282-.132.594-.413.633-.281.04-.592-.133-.632-.415-2.041-9.425 3.335-19.606 4.251-21.245l-5.665-14.816c-.77-1.907.068-4.11 1.936-5.093 1.939-.992 4.316-.39 5.437 1.466l9.487 15.502a17.061 17.061 0 0 1 2.394 8.37c.02.14-.494 13.306.1 17.54.427 3.033 2.714 9.619 2.724 9.69.11.272-.061.583-.332.694l-.211.03Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M29.27 38.341s-7.06-2.82-6.874-6.588c.187-3.768 5.654-2.09 5.654-2.09l1.22 8.678Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M29.34 38.834c-.07.01-.211.03-.291-.031-.301-.102-7.452-3.054-7.234-7.113.072-1.018.465-1.792 1.178-2.324 1.829-1.264 5.039-.349 5.189-.298.22.041.32.243.35.454l1.22 8.678c.03.212-.02.363-.221.463.02.141-.05.151-.191.17Zm-4.491-9.01c-.422.06-.904.2-1.225.46-.452.352-.674.815-.725 1.47-.095 2.387 3.514 4.613 5.67 5.677l-1.04-7.408c-.593-.132-1.767-.327-2.68-.199Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M33.066 61.262s-1.937-.015-3.133 1.16c-1.197 1.175-1.893 3.36.1 5.814.871 1.1 6.054 4.329 7.333 1.703 1.4-2.787-4.284-6.52-4.284-6.52l-.016-2.157Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m36.068 71.415-.07.01c-2.26.246-5.577-1.95-6.358-2.92-2.093-2.655-1.437-5.121-.06-6.538 1.318-1.336 3.395-1.34 3.465-1.35.291.03.532.213.501.505l-.023 1.874c1.112.779 5.673 4.167 4.213 7.034-.232.896-.895 1.277-1.668 1.385Zm-3.567-9.57c-.562.078-1.536.287-2.16.95-.623.663-1.94 2.504.143 5.088.61.778 3.678 2.721 5.365 2.484.491-.069.823-.26 1.054-.652.947-1.931-2.62-4.883-4.114-5.825-.16-.121-.25-.252-.21-.474l-.078-1.572Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M31.344 53.088s-2.007-.006-3.194 1.24c-1.256 1.256-1.652 4.045-.181 6.357.82 1.251 6.445 4.562 7.755 1.644 1.31-2.918-4.152-7.618-4.152-7.618l-.228-1.623Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m34.235 63.977-.211.03c-2.339.185-5.787-1.92-6.518-3.041-1.642-2.503-1.145-5.595.233-7.012 1.377-1.416 3.534-1.36 3.605-1.37.29.031.461.223.49.435l.19 1.34c.991.94 5.45 5.134 4.08 8.132-.242.826-.956 1.358-1.87 1.486ZM30.78 53.671c-.633.089-1.596.368-2.22 1.031-1.065 1.085-1.43 3.583-.13 5.702.54.788 3.608 2.73 5.525 2.605.633-.089 1.105-.299 1.316-.832.917-2.144-2.529-5.76-3.992-6.993a.545.545 0 0 1-.19-.334l-.149-1.058c-.09-.131-.09-.131-.16-.121Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M30.164 44.69s-2.008-.005-3.194 1.24c-1.186 1.247-1.332 4.289-.181 6.358.69 1.341 6.253 5.236 7.673 2.087 1.491-3.16-4.07-8.062-4.07-8.062l-.228-1.622Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m32.974 56.023-.351.05c-2.43.053-5.726-2.505-6.307-3.575-1.24-2.2-1.064-5.534.243-6.941 1.377-1.417 3.535-1.36 3.605-1.37.291.031.461.223.491.435l.188 1.34c.912.88 5.551 5.335 4.07 8.565-.382.845-1.026 1.367-1.94 1.496ZM29.6 45.273c-.632.09-1.596.369-2.22 1.032-1.065 1.085-1.1 3.896-.13 5.702.39.736 3.367 3.052 5.364 2.987.643-.018 1.105-.299 1.377-.913 1.037-2.304-2.509-6.122-3.912-7.436a.545.545 0 0 1-.19-.333l-.148-1.058-.14.02ZM57.398 67.267l-19.474 2.737a.55.55 0 0 1-.618-.488c-.05-.353.123-.593.46-.64l19.474-2.738a.55.55 0 0 1 .618.49.55.55 0 0 1-.46.64Z"
  }), React.createElement("path", {
    fill: borderColor,
    fillRule: "evenodd",
    d: "M38.67 17.261a.525.525 0 0 1 .445-.593l4.1-.585a.525.525 0 0 1 .148 1.039l-4.1.584a.525.525 0 0 1-.593-.445Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M30.171 44.761a.56.56 0 0 1-.641-.485L25.99 19.09c-.258-1.834 1-3.594 2.897-3.86l23.258-3.27a3.414 3.414 0 0 1 3.849 2.913L58.81 34.91a.56.56 0 0 1-.483.644c-.351.049-.592-.133-.642-.486L54.87 15.03c-.178-1.27-1.38-2.18-2.645-2.002l-23.118 3.249c-1.265.178-2.17 1.384-1.992 2.654l3.55 25.258c.04.282-.212.533-.493.572Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m47.865 25.31 6.756-16.1c.692-1.648 2.918-1.94 4.008-.528l10.645 13.813c1.09 1.413.225 3.473-1.556 3.707L50.315 28.49c-1.78.234-3.142-1.533-2.45-3.18Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "m58.238 18.876-.758.1c-.35.045-.675-.169-.75-.494l-1.088-4.322c-.087-.373.183-.74.584-.792l1.791-.236c.4-.052.755.232.767.615l.054 4.458c.01.334-.25.625-.6.67Zm-.214 2.28a1.591 1.591 0 0 0-1.369 1.784c.113.87.91 1.483 1.779 1.37a1.591 1.591 0 0 0 1.369-1.784 1.586 1.586 0 0 0-1.779-1.37Z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "WhatsAppFeedbackAlert_svg__a"
  }, React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M0 0h96v96H0z"
  }))));
};
export default SvgWhatsAppFeedbackAlert;